import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { TRANSLATIONS_HI } from './hi/translation';
import { TRANSLATIONS_EN } from './en/translation';

import { TRANSLATIONS_BN } from './bn/translation';
import { TRANSLATIONS_GU } from './gu/translation';
import { TRANSLATIONS_KN } from './kn/translation';
import { TRANSLATIONS_MR } from './mr/translation';
import { TRANSLATIONS_TA } from './ta/translation';
import { TRANSLATIONS_TE } from './te/translation';
import { TRANSLATIONS_EN_STATE } from './en_State/translation';
import { TRANSLATIONS_EN_PAINT } from './en_paint/translation';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: TRANSLATIONS_EN(),
      },
      en_state: {
        translation: TRANSLATIONS_EN_STATE(),
      },
      hi: {
        translation: TRANSLATIONS_HI,
      },
      bn: {
        translation: TRANSLATIONS_BN,
      },
      gu: {
        translation: TRANSLATIONS_GU,
      },
      kn: {
        translation: TRANSLATIONS_KN,
      },
      mr: {
        translation: TRANSLATIONS_MR,
      },
      ta: {
        translation: TRANSLATIONS_TA,
      },
      te: {
        translation: TRANSLATIONS_TE,
      },
      en_paint: {
        translation: TRANSLATIONS_EN_PAINT(),
      },
    },
  });

export default i18n;
